
import React, { Component } from 'react';
import { Modal } from "react-bootstrap";
import './customColumnsModal.css';

class CustomColumnsModel extends Component {
    constructor(props) {
        super(props);
        this.state = {
            selectedColumns: [],
            duplicate:'',
        }
        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleInputChange = this.handleInputChange.bind(this);
    }

    handleModal(){
        this.props.parentCallback(''); 
    } 
    handleSubmit() {
        this.props.parentCallback('add', this.state.selectedColumns, this.state.duplicate);
    }
      // handle input change
    handleInputChange(checked, i) {
        const list = [...this.props.allcolumns];
        list[i]['checked'] = checked;
        this.setState({selectedColumns: list}) 
    };

  render(){ 
    return(
        <Modal
            aria-labelledby="cms-columns-modal-title"
            centered
            show={this.props.show}
            onHide={() => this.handleModal()}
            backdropClassName="cms-columns-modal-backdrop"
            dialogClassName="cms-columns-modal-dialog"
            contentClassName="cms-columns-modal-content"
            className="cms-columns-modal"
        >
            <Modal.Header closeButton className="cms-columns-modal-header">
                <Modal.Title id="cms-columns-modal-title" className="cms-columns-modal-title">
                    Set Columns
                </Modal.Title>
            </Modal.Header>

            <Modal.Body className="cms-columns-modal-body">
                <p className="cms-columns-modal-subtitle">
                    Select columns to show in table
                </p>
                <div className="cms-columns-modal-grid">
                    {this.props.allcolumns.map((value, i) => (
                        value.canChange === true && (
                            <label className="cms-columns-modal-option" key={i} htmlFor={`cms-column-${i}`}>
                                <input
                                    id={`cms-column-${i}`}
                                    type="checkbox"
                                    defaultChecked={value.checked}
                                    onChange={(e) => this.handleInputChange(e.target.checked, i)}
                                />
                                <span className="cms-columns-modal-option-label">{value.title}</span>
                            </label>
                        )
                    ))}
                </div>

                {this.props.showDuplicateEntry && (
                    <label className="cms-columns-modal-duplicate" htmlFor="cms-column-duplicate">
                        <input
                            id="cms-column-duplicate"
                            type="checkbox"
                            defaultChecked={this.props.defaultDuplicate}
                            onChange={(e) => this.setState({ duplicate: e.target.checked })}
                        />
                        <span className="cms-columns-modal-duplicate-label">
                            Show Duplicate Enteries
                        </span>
                    </label>
                )}
            </Modal.Body>

            <Modal.Footer className="cms-columns-modal-footer">
                <button
                    type="button"
                    className="cms-columns-modal-btn-cancel"
                    onClick={() => this.handleModal()}
                >
                    Cancel
                </button>
                <button
                    type="button"
                    className="cms-columns-modal-btn-apply"
                    onClick={this.handleSubmit}
                >
                    Add
                </button>
            </Modal.Footer>
        </Modal>
    )
    }
}
export default CustomColumnsModel
